export default {
  1: ['#1F49D1', '#4CF1BD'],
  2: ['#CD261E', '#EF8631'],
  3: ['#2644C8', '#9E218E'],
};
